<template>
  <div class="medicamentos-details">
    <page-header :title="title" />
    <page-section>
      <v-row no-gutters>
        <v-col class="mb-4" cols="12">
          <field-section
            :label="$t('Medicamentos')"
            :value="tag.medicamentos | toPT_BRCapitalize"
            :is-restrict="
              $store.getters['tagFuncionario/isRestrict']('medicamentos')
            "
          />
        </v-col>
      </v-row>
    </page-section>
    <Form :title="title" :data="tag" />
  </div>
</template>

<script>
import i18next from "i18next";
import PageHeader from "@/components/headers/page-header";
import PageSection from "@/components/sections/page-section";
import FieldSection from "@/components/sections/field-section";
import Form from "./form";
export default {
  metaInfo: {
    titleTemplate: (i18next.t("Medicamentos") || "") + " | %s",
  },
  components: { FieldSection, PageSection, PageHeader, Form },
  data: () => ({
    title: i18next.t("Medicamentos"),
  }),
  computed: {
    tag() {
      return this.$store.state.tagFuncionario.data || {};
    },
  },
};
</script>

<style scoped></style>
